import React from 'react';

import componentsFactory from './componentsFactory';
import {componentsMap} from './config';

const CONFIGURATIONS_REGEX_LIST = [
	/Config$/,
	/^PersonalizedItem$/,
	/^PersonalizedBlockPersonalizedItemsCollection$/,
	/^Sys$/,
];

/**
 * Props that should be kept as raw data instead of being built into React elements.
 * Key: parent component __typename. Value: array of prop names to preserve as data.
 */
const propsAsData: Record<string, string[]> = {
	FlatNavigationItem: ['targetPage'],
	NavigationItem: ['targetPage'],
};

/**
 * Represents ComponentsConfigsMgr
 */
class ComponentsConfigsMgr {
	/**
	 * Checks if passed typename is simple configuration from Contentful and not component to build
	 * @param typename Typename to check according to regex constant
	 * @returns {Boolean}
	 */
	isConfiguration(typename: string): boolean {
		return typename ? CONFIGURATIONS_REGEX_LIST.some((regex) => regex.test(typename)) : false;
	}

	/**
	 * Returns component class according to the type
	 * @param typename Type of component to return
	 * @returns {React.FC}
	 */
	get(typename: keyof typeof componentsMap): React.FC {
		return componentsFactory.create(typename);
	}

	/**
	 * Checks if a prop should be kept as raw data instead of being built into a React element
	 * @param parentTypename __typename of the parent component
	 * @param propKey Name of the prop to check
	 * @returns {Boolean}
	 */
	shouldKeepAsData(parentTypename: string, propKey: string): boolean {
		return propsAsData[parentTypename]?.includes(propKey) ?? false;
	}
}

export default new ComponentsConfigsMgr();
